<script>
	var _ = require('underscore');
	var Grading = require('../readworks-grading');
	module.exports = {
		props: ['student', 'questions', 'closed'],
		data: function () {
			return {
				totalRight: 0,
				gradingComplete: false,
				colorsByQid: {}
			};
		},
		mounted() {
			this.$watch('student', _.bind(this.calculateTotalRightAndSetColors, this));
			this.$watch('questions', _.bind(this.calculateTotalRightAndSetColors, this), {
				deep: true,
				immediate: true
			});
		},
		methods: {
			getColorClassForNumber: function (n) {
				switch (n) {
					case 100:
						return '-g100';
					case 75:
						return '-g75';
					case 50:
						return '-g50';
					case 25:
						return '-g25';
					default:
						return '-g0';
				}
			},
			getColorClassFor: function (q) {
				let student = this.student;
				let hasWorkspace = student.hasWorkspace;
				let submitted = student.submitted;
				let closed = this.closed;
				if (Grading.questionTypeIsScorable(q.questionType)) {
					if (submitted || closed) {
						return this.getColorClassForNumber(q.score || 0);
					} else if (typeof q.score === 'number') {
						return this.getColorClassForNumber(q.score);
					} else {
						return '-unanswered';
					}
				} else if (submitted || (closed && hasWorkspace)) {
					if (typeof q.score === 'number') {
						return this.getColorClassForNumber(q.score);
					} else {
						return '-needs-grading';
					}
				} else if (closed && !hasWorkspace) {
					return this.getColorClassForNumber(0);
				} else if (q.answered) {
					return '-needs-grading';
				} else {
					return '-unanswered';
				}
			},
			calculateTotalRightAndSetColors: function () {
				var totalRight = 0,
					gradingComplete = true,
					colorsByQid = {},
					self = this;
				_.each(this.questions, function (q) {
					if (typeof q.score === 'number' || Grading.questionTypeIsScorable(q.questionType)) {
						totalRight += (q.score || 0) / 100;
					} else {
						gradingComplete = false;
					}

					colorsByQid[q.qid] = self.getColorClassFor(q);
				});

				if (this.closed && this.student && !this.student.hasWorkspace) {
					gradingComplete = true;
				}

				this.totalRight = totalRight;
				this.gradingComplete = gradingComplete;
				this.colorsByQid = colorsByQid;
			}
		}
	};
</script>
<template>
	<span>
		<span
			v-for="q in questions"
			:key="q.qid"
			:data-qid="q.qid"
			:class="['grade-badge', colorsByQid[q.qid], 'print-hidden']">
		</span>
		<small
			class="grade-badge-total"
			v-if="gradingComplete">
			{{ questions.length > 0 ? Math.round((100 * totalRight) / questions.length) + '%' : 'N/A' }}
		</small>
	</span>
</template>
